export default {
  EMPTY_STUB: "app__empty-stub",
  MODAL_HEADER: "app__modal__header",
  MODAL_ICON_CLOSE: "app__modal__close-icon"
};
